var _path, _g, _g2, _rect, _rect2, _rect3, _rect4, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistrataBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 56",
    style: {
      enableBackground: "new 0 0 40 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M37.3,56h-35C1,56,0,55,0,53.7V10.6c0-1.3,1-2.3,2.3-2.3h3.2v2H2.3c-0.2,0-0.3,0.2-0.3,0.4v43.1 c0,0.2,0.1,0.4,0.3,0.4h35c0.2,0,0.3-0.2,0.3-0.4V10.6c0-0.2-0.1-0.4-0.3-0.4h-3.5v-2h3.5c1.2,0,2.3,1,2.3,2.3v43.1 C39.5,55,38.5,56,37.3,56z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M13.2,28.9v0.3H8.4v-4.9h3.7l2.4-1.9c-0.1,0-0.2,0-0.3,0H7.4c-0.5,0-1,0.4-1,1v6.8c0,0.5,0.4,1,1,1h6.8 c0.5,0,1-0.4,1-1v-2.8L13.2,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M11.1,28.8H11c-0.3,0-0.5-0.2-0.7-0.4l-1.2-1.6c-0.3-0.4-0.2-1,0.2-1.4c0.4-0.3,1-0.2,1.4,0.2l0.6,0.8l3.9-3.1 c0.4-0.3,1-0.3,1.4,0.2c0.3,0.4,0.3,1-0.2,1.4l-4.7,3.7C11.5,28.7,11.3,28.8,11.1,28.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M13.2,41.4v0.3H8.4v-4.9h3.7l2.4-1.9c-0.1,0-0.2,0-0.3,0H7.4c-0.5,0-1,0.4-1,1v6.8c0,0.5,0.4,1,1,1h6.8 c0.5,0,1-0.4,1-1v-2.8L13.2,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M11.1,41.3H11c-0.3,0-0.5-0.2-0.7-0.4l-1.2-1.6c-0.3-0.4-0.2-1,0.2-1.4c0.4-0.3,1-0.2,1.4,0.2l0.6,0.8l3.9-3.1 c0.4-0.3,1-0.3,1.4,0.2c0.3,0.4,0.3,1-0.2,1.4l-4.7,3.7C11.5,41.3,11.3,41.3,11.1,41.3z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.8,
    y: 23.8,
    className: "st0icon",
    width: 6.3,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8,
    y: 27.4,
    className: "st0icon",
    width: 11.4,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8,
    y: 36.7,
    className: "st0icon",
    width: 6.3,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8,
    y: 40.3,
    className: "st0icon",
    width: 11.4,
    height: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M29.9,13.6H9.6c-1.2,0-2.1-0.9-2.1-2.1V7.2c0-1.2,0.9-2.1,2.1-2.1h5.2c0-0.1,0-0.1,0-0.2c0-2.7,2.2-5,5-5 c2.7,0,5,2.2,5,5c0,0.1,0,0.1,0,0.2H30c1.2,0,2.1,0.9,2.1,2.1v4.3C32,12.7,31.1,13.6,29.9,13.6z M9.6,7.1c-0.1,0-0.1,0.1-0.1,0.1 v4.3c0,0.1,0.1,0.1,0.1,0.1H30c0.1,0,0.1-0.1,0.1-0.1V7.2c0-0.1-0.1-0.1-0.1-0.1h-6.4c-0.3,0-0.6-0.1-0.8-0.4 c-0.2-0.2-0.2-0.6-0.2-0.9c0.1-0.3,0.1-0.6,0.1-0.9c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.3,0,0.6,0.1,0.9s0,0.6-0.2,0.9 c-0.2,0.2-0.5,0.4-0.8,0.4H9.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M20.6,4.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9C20.2,3.8,20.6,4.2,20.6,4.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrataBlu);
export default __webpack_public_path__ + "static/media/registrataBlu.8afaa8f0.svg";
export { ForwardRef as ReactComponent };